import { render, staticRenderFns } from "./APrimaryBtn.vue?vue&type=template&id=324c7132&"
import script from "./APrimaryBtn.vue?vue&type=script&lang=ts&"
export * from "./APrimaryBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports